module.exports = __webpack_public_path__ + "img/yunjisuan.bf6477af.png";